;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();import { heicTo, isHeic } from 'heic-to';

export const HEIC_PICKER_ACCEPT = 'image/heic,image/heif,.heic,.heif';

const HEIC_MIME_TYPES = new Set(['image/heic', 'image/heif']);
const HEIC_EXTENSIONS = ['.heic', '.heif'];
const KNOWN_NON_HEIC_EXTENSIONS = [
  '.pdf',
  '.png',
  '.jpg',
  '.jpeg',
  '.gif',
  '.webp',
  '.bmp',
  '.csv',
  '.xls',
  '.xlsx',
  '.doc',
  '.docx',
];
const JPEG_QUALITY = 0.9;

export interface ConvertHeicFilesResult {
  files: File[];
  failedFileNames: string[];
}

export function withHeicPickerAccept(base: string): string {
  const tokens = new Set(
    `${base},${HEIC_PICKER_ACCEPT}`
      .split(',')
      .map((token) => token.trim())
      .filter(Boolean)
  );
  return Array.from(tokens).join(',');
}

function getFileExtension(name: string): string {
  const lastDot = name.lastIndexOf('.');
  if (lastDot <= 0 || lastDot === name.length - 1) return '';
  return name.slice(lastDot).toLowerCase();
}

function hasHeicExtensionOrMime(file: File): boolean {
  const extension = getFileExtension(file.name);
  if (HEIC_EXTENSIONS.includes(extension)) return true;
  return HEIC_MIME_TYPES.has(file.type.toLowerCase());
}

function hasKnownNonHeicExtension(file: File): boolean {
  return KNOWN_NON_HEIC_EXTENSIONS.includes(getFileExtension(file.name));
}

function toJpegFileName(name: string): string {
  if (/\.(heic|heif)$/i.test(name)) return name.replace(/\.(heic|heif)$/i, '.jpg');
  if (name.includes('.')) return name.replace(/\.[^.]+$/, '.jpg');
  return `${name}.jpg`;
}

export async function isHeicFile(file: File): Promise<boolean> {
  if (hasHeicExtensionOrMime(file)) return true;
  if (file.type && !file.type.toLowerCase().startsWith('image/')) return false;
  if (hasKnownNonHeicExtension(file)) return false;

  try {
    return await isHeic(file);
  } catch {
    return false;
  }
}

export async function convertHeicFilesToJpeg(files: File[]): Promise<ConvertHeicFilesResult> {
  const converted: File[] = [];
  const failedFileNames: string[] = [];

  for (const file of files) {
    const fileIsHeic = await isHeicFile(file);
    if (!fileIsHeic) {
      converted.push(file);
      continue;
    }

    try {
      const blob = await heicTo({
        blob: file,
        type: 'image/jpeg',
        quality: JPEG_QUALITY,
      });
      converted.push(
        new File([blob], toJpegFileName(file.name), {
          type: 'image/jpeg',
          lastModified: file.lastModified,
        })
      );
    } catch {
      failedFileNames.push(file.name);
    }
  }

  return { files: converted, failedFileNames };
}
